import { combineReducers } from "redux"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import userReducer from "./user/user.reducers"
import cartReducer from "./cart/cart.reducers"
import { cakeReducer } from "./cake/cake.reducers"

const persistConfig = {
  key: "root",
  storage,
  //   whitelist: ["user"], // note this will not gonna persist cart history
  whitelist: ["cart", "user"], // note: this will cache login user and cart
}

const rootReducer = combineReducers({
  user: userReducer,
  cart: cartReducer,
  cake: cakeReducer,
})

export default persistReducer(persistConfig, rootReducer)
